// Public contact details shown across the main site (footer, About, Privacy).
export const CALL_NUMBER_DISPLAY = "+91 8065356108";
export const CALL_NUMBER_TEL = "tel:+918065356108";
export const SUPPORT_EMAIL = "support@muviarts.in";
